// src/ParallaxTextPunchout.jsx
import React, { useMemo } from "react";
import "./ParallaxTextPunchout.css";

export default function ParallaxTextPunchout({
  text = "GANBARU",
  fontSize = "12vw",
  fontWeight = 400,
  fontFamily = "TestFont",
}) {
  // Break text into 2-character chunks: "EXPLORAR" -> "EX\nPL\nOR\nAR"
  const formattedText = useMemo(() => {
    if (!text) return "";
    const lines = [];
    for (let i = 0; i < text.length; i += 2) {
      lines.push(text.slice(i, i + 2));
    }
    return lines.join("\n");
  }, [text]);

  return (
    <div className="ppt-fullscreen">
      <div className="ppt-text-mask">
        <div
          className="ppt-text-mask-inner"
          data-text={formattedText}
          style={{
            "--fs": fontSize,
            "--fw": fontWeight,
            "--ff": fontFamily,
          }}
        >
          {formattedText}
        </div>
      </div>
    </div>
  );
}
